import React from 'react';
import { PlayerStatusContainer } from '../../../components/display/PlayerStatusContainer';

export const PlayerStartingView: React.FC = () => {
  return <PlayerStatusContainer title="Get Ready!" subtitle="Look at the main screen for the prompt!" />;
};
